import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PartnerListState, PARTNER_LIST_STATE } from './partner-list.state';

export const selectPartner =
  createFeatureSelector<PartnerListState>(PARTNER_LIST_STATE);

export const selectPartnerList = createSelector(
  selectPartner,
  (state: PartnerListState) => {
    return state.dataSource;
  }
);

export const selectPartnerListFilter = createSelector(
  selectPartner,
  (state: PartnerListState) => state.filter
);
